import type { EMandateBankCapabilities } from "../api/mandate";
import {
  BANK_SERVICE_CAPABILITY_WARNING_KEY,
  BANK_SERVICE_CAPABILITY_WARNING_MESSAGES,
  EMANDATE_BANK_CAPABILITY_KEYS,
  type BankServiceCapabilityWarningKey,
} from "../constants/bank-service-capabilities";

export function getBankServiceCapabilityWarningKey(
  capabilities?: EMandateBankCapabilities | null
): BankServiceCapabilityWarningKey | null {
  if (!capabilities) {
    return null;
  }

  const emandateFlags = EMANDATE_BANK_CAPABILITY_KEYS.map(
    (key) => capabilities[key]
  );
  const allEmandateDisabled = emandateFlags.every((enabled) => !enabled);

  if (!capabilities.payment_netbanking_enabled && allEmandateDisabled) {
    return BANK_SERVICE_CAPABILITY_WARNING_KEY.NETBANKING_AND_EMANDATE_NOT_SUPPORTED;
  }

  if (!capabilities.payment_netbanking_enabled && !allEmandateDisabled) {
    return BANK_SERVICE_CAPABILITY_WARNING_KEY.NETBANKING_NOT_SUPPORTED;
  }

  if (capabilities.payment_netbanking_enabled && allEmandateDisabled) {
    return BANK_SERVICE_CAPABILITY_WARNING_KEY.EMANDATE_NOT_SUPPORTED;
  }

  return null;
}

export function getBankServiceCapabilityWarningMessage(
  capabilities?: EMandateBankCapabilities | null
): string | null {
  const key = getBankServiceCapabilityWarningKey(capabilities);
  return key ? BANK_SERVICE_CAPABILITY_WARNING_MESSAGES[key] : null;
}
